// The snackbar is a single element rendered by the app shell, so this looks it
// up on use rather than holding it in state. Holding it meant the element was
// null until the mount effect had run, and writing innerText on a state value.
//
// Nothing here touches React, so it is exported as a plain function too: the
// rejection sinks in helpers are not components and cannot call a hook.
export const showSnackbar = (message: string, snackbar_class = "") => {
  const snackbar = document.getElementById("snackbar");
  if (!snackbar) return;
  snackbar.classList.add("show");
  if (snackbar_class) snackbar.classList.add(snackbar_class);
  snackbar.innerText = message;
  setTimeout(() => {
    snackbar.classList.remove("show");
    if (snackbar_class) snackbar.classList.remove(snackbar_class);
  }, 3000);
};

const useSnackbar = () => {
  return { showSnackbar };
};

export default useSnackbar;
